<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>

                <v-row justify="center">
                    <v-col class="text-center">
                        <div class="text-uppercase font-weight-bold primary--text text-h5">
                            Editar usuario
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="4">
                        <v-form ref="form" @submit.prevent="save">
                            <users-form :values="form" :edit="true"></users-form>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
			<v-row justify="center" align="end">
				<v-col cols="12" md="4" class="text-right">
					<v-btn class="full-width-btn" tile text color="primary" :to="{ name: 'Usuarios' }">Cancelar</v-btn>
					<v-btn tile color="secondary" class="ml-md-2 ml-0 mt-md-0 mt-3 full-width-btn text-base-color" @click="save">Guardar</v-btn>
				</v-col>
            </v-row>
            <snackbar :props="snackbarProps"></snackbar>
        </template>
    </contentCard>
</template>

<script>
import UsersForm from './Form.vue'

export default {
	components: {
		'users-form': UsersForm
	},
	data(){
		return {
            loading:true,
            id: this.$route.params.id,
			form: {
                name: '',
                phone: '',
				email: '',
				password: '',
				password_confirmation: '',
				status: 'Activo',
                role_id: '',
                business:[]
			},
			
			snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
			},
		}
	},
	mounted(){
		this.index()
	},
	methods: {
		validate () {
			return this.$refs.form.validate()
		},
		index(){
			this.loading = true
            this.$http.get(this.$store.state.apiRoute+'/users/'+this.id+'/edit')
            .then((response) => {
                this.form = {
					// seller_id: response.data.slug,
                    name: response.data.name,
                    phone: response.data.phone,
					email: response.data.email,
					status: response.data.status,
                    role_id: response.data.role_slug,
                    business: response.data.business??[]
				}
            })
            .catch(error => {
                error
            })
            .finally(() => {
                this.loading = false
            })
        },
		save(){
			if(this.validate()){
				this.$store.state.overlay = true
				this.$http.put(this.$store.state.apiRoute+'/users/'+this.id+'/update', this.form)
				.then(() => {
					this.$store.state.globalSnackbarProps.visible = true
					this.$store.state.globalSnackbarProps.text = 'Se ha actualizado correctamente el usuario <b></b>'
					this.$router.push({ name: 'Usuarios' })
				}).catch((error) => {
					var errors = []
					switch(error.response.status){
						case 422: 
							Object.keys(error.response.data.errors).forEach((x) => {
								error.response.data.errors[x].forEach((y) => {
									errors.push(y)
								})
							})
						break;
						case 500: 
							errors.push('Error en el servidor. Intente de nuevo.')
						break;
						case 404: 
							errors.push('404 Not found.')
						break;
					}

					this.snackbarProps = {
						visible: true,
						color: 'error',
						timeout: 10000,
						text: errors.join('.<br>'),
					}
				})
				.finally(() => {
					this.$store.state.overlay = false
				})
			}else{
				this.snackbarProps = {
					visible: true,
					color: 'error',
					timeout: 2000,
					text: 'Formulario incompleto',
				}

				this.$store.state.overlay = false
			}
		}
	}
}
</script>

<style>

</style>